import React from 'react';
import Parcel from 'single-spa-react/parcel';
import { mountRootParcel } from 'single-spa';
import { useNavigate } from 'react-router-dom';

const systemImport = (name: string): Promise<any> =>
    (window as any).System.import(name);

// V2 login using IAM API + AuthUtility (zustand persisted to localStorage "authStore").
// After login the zustand store is already populated — AppointmentsParcel reads it via
// http-client-utils.ts which reads authStore from localStorage on every request.
// No Redux bridge needed here; the legacy /adminLogin → /patients flow is untouched.
const PracticeLoginParcel: React.FC = () => {
    const navigate = useNavigate();

    return (
        <Parcel
            config={() => systemImport('@Smalljoys/PracticeLogin')}
            mountParcel={mountRootParcel}
            onLoginSuccess={() => navigate('/appointments')}
        />
    );
};

export default PracticeLoginParcel;
